// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__39jur","rootSuccess":"CompleteLink_rootSuccess__16O9T","rootFailure":"CompleteLink_rootFailure__2lxCj","isDisabled":"CompleteLink_isDisabled__SAEJS"};